import React from 'react';
import {connect} from "react-redux";
import {compose} from "redux";
import {Button, Card, Col, Row} from "antd";
import ChatWall from "../../Boilerplate/ChatWall";
import {CodeTag} from "../../Boilerplate/CodeTag";
import DateDisplay from "../../Boilerplate/DateDisplay";
import UserSmall from "../../Boilerplate/UserSmall";
import {canUpdate} from "../../Boilerplate/permissions";
import {TaskFiles} from "./TaskFiles";
import {compArr} from "../selectors";

const TaskDetail = ({ task, projectId, onEdit }) => {
  const rowWidth = 24;
  const keyWidth = 11;
  const valWidth = rowWidth - keyWidth;
  return (
    <Row gutter={24}>
      <Col span={17}>
        <Card
          className='bid-dashboard-info'
          title={`Task #${task.resource.number} - ${task.resource.name}`}
          extra={
            <Button.Group>
              <Button onClick={onEdit} disabled={!canUpdate(task)}>Edit</Button>
            </Button.Group>
          }
        >
          <Row>
            <Col span={12}>
              <Row className='key-value'>
                <Col span={keyWidth}>Assigned To</Col>
                <Col span={valWidth}><UserSmall id={task.resource.owneruserid}/></Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Due</Col>
                <Col span={valWidth}><DateDisplay date={task.resource.duedate}/></Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Priority</Col>
                <Col span={valWidth}><CodeTag table='taskpriority' code={task.resource.priority}/></Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Status</Col>
                <Col span={valWidth}><CodeTag table='taskstatus' code={task.resource.status}/></Col>
              </Row>
            </Col>
          </Row>
          <p className='formatted-text'>
            {task.resource.description}
          </p>
        </Card>
        <TaskFiles/>
      </Col>
      <Col span={7}>
        <ChatWall projectId={projectId} taskId={task.resource.id}/>
        {/*<Activity/>*/}
      </Col>
    </Row>
  );
};

export default compose(
  connect(
    (state, props) => {
      const projectId = props.match.params.id;
      const task = state.view.subview.data[props.match.params.taskId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'tasks', props.match.params.taskId];
      if (!compArr(path, itempath) || loading || !task) return { loading: true };
      return { task, projectId };
    },
    (dispatch, props) => ({
      onEdit: () => props.history.push(`/projects/${props.match.params.id}/tasks/${props.match.params.taskId}/edit`)
    })
  ),
)(TaskDetail);



// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/TaskDetail.js